export const openWhatsapp = (mobile) => {
  const formattedMobile =
    mobile.startsWith("+") || mobile.startsWith("34") || mobile.startsWith("0034")
      ? mobile
      : "+34" + mobile;
  window.open("https://web.whatsapp.com/send/?phone=" + formattedMobile, "_blank");
};
